import { Tooltip } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { RequestStatus } from '../../../common/enums/requestStatus';
import { ThirdPartyMessageStatus } from '../../../common/enums/thirdPartyMessageStatus';
import { TherapielandSsoLink } from '../elements/TherapielandSsoLink';
import { Feedback } from './common';
import { ProgressBar } from './ProgressBar';

export interface IInvitationStatusProps {
    allInvitationsFailedToSend: boolean;
    failedToGetAllProgress: boolean;
    failedToGetProgress: boolean;
    hasAccessToCounseling: boolean;
    linkId: string;
    messageStatus: ThirdPartyMessageStatus;
    percentage: number;
    requesterOrganizationId: string;
    requesterPractitionerId: string;
    requestId: string;
    requestStatus: RequestStatus;
    therapielandCounselingId: number;
    title: string;
}

export function InvitationStatus(props: Readonly<IInvitationStatusProps>) {
    const language = getSelectedLanguage();
    const failedToSend = props.messageStatus === ThirdPartyMessageStatus.failed && !props.allInvitationsFailedToSend;
    const failedToGetProgress =
        props.requestStatus !== RequestStatus.accepted && props.failedToGetProgress && !props.failedToGetAllProgress;

    return (
        <ProgressBar
            feedback={
                <>
                    {failedToSend && <Feedback error={'failedToSendInvitation'} />}
                    {!failedToSend && failedToGetProgress && (
                        <Feedback error={'failedToGetUpdatedInvitationProgress'} />
                    )}
                </>
            }
            percentage={props.percentage}
            statusText={getStatusText()}
            title={
                <Tooltip
                    content={`ID:${props.therapielandCounselingId}`}
                    hasArrow={false}
                    placement="right"
                >
                    <TherapielandSsoLink
                        dataToLinkToPatientContext={{
                            requestId: props.requestId,
                            requestStatus: props.requestStatus,
                            requesterOrganizationId: props.requesterOrganizationId,
                            requesterPractitionerId: props.requesterPractitionerId,
                        }}
                        hasAccessToCounseling={props.hasAccessToCounseling}
                    >
                        {props.title}
                    </TherapielandSsoLink>
                </Tooltip>
            }
        />
    );
    function getStatusText() {
        if (props.messageStatus === ThirdPartyMessageStatus.failed) {
            return language.StatusLabelEnum.failed;
        }

        switch (props.requestStatus) {
            case RequestStatus.aborted:
                return language.StatusLabelEnum.cancelled;
            case RequestStatus.completed:
                return language.StatusLabelEnum.closed;
            case RequestStatus.accepted:
                return language.StatusLabelEnum.invited;
            case RequestStatus.active:
                return language.StatusLabelEnum.started;
            default:
                return '';
        }
    }
}
